<div class="infoBox pdfHide">
  <div class="eyebrow" [style.color]="brandColour()">Permissions renewal</div>
  <div class="title">
    @if (currentStage() === 'data') {
      The hard part is done!
    } @else {
      Keep tracking your {{ buildingPossessive() }} energy data uninterrupted
    }
  </div>
  <div class="sub-title">
    @if (currentStage() === 'data') {
      We'll continue showing you exactly where and when you're spending the most — and how to reduce it.
    } @else {
      Renew your data access permissions. We'll continue showing you exactly where and when you're spending the most — and how to reduce it.
    }
  </div>

  <div class="px-3">
    <div class="d-flex align-items-center stage" [class.currentStage]="currentStage() === 'shared'">
      <fa-icon class="icon" [class.green]="isCompleted('shared')" [class.futureStateIcon]="isFuture('shared')" [style.color]="currentStage() === 'shared' ? brandColour() : null" [icon]="['far', 'check-circle']"></fa-icon>
      <div class="ps-3 stateText" [class.green]="isCompleted('shared')" [class.futureStateText]="isFuture('shared')" [style.color]="currentStage() === 'shared' ? brandColour() : null">Your MPANs or MPRNs remain active in our system</div>
    </div>
    <div class="d-flex align-items-center stage" [class.currentStage]="currentStage() === 'added'">
      <fa-icon class="icon" [class.green]="isCompleted('added')" [class.futureStateIcon]="isFuture('added')" [style.color]="currentStage() === 'added' ? brandColour() : null" [icon]="['far', 'check-circle']"></fa-icon>
      <div class="ps-3 stateText" [class.green]="isCompleted('added')" [class.futureStateText]="isFuture('added')" [style.color]="currentStage() === 'added' ? brandColour() : null">Your buildings are actively monitored</div>
    </div>
    <div class="d-flex align-items-center stage">
      <fa-icon class="icon green" [icon]="['far', 'check-circle']"></fa-icon>
      <div class="ps-3 stateText green">We'll maintain seamless access to your ongoing meter data and historical insights*</div>
    </div>
  </div>

  <div class="pt-1 additionalText grey">* Continuous data tracking relies on up-to-date Letter of Authority permissions as required by data and meter providers. </div>
</div>
